import React, { useState, useEffect } from 'react';
import classnames from 'classnames';
import { usePrefixCls } from '../_utils';
import { ThumbnailProps } from './interface';

const Thumbnail: React.FC<ThumbnailProps> = props => {
  const { active, imageUrl, className, style, onChoose = () => {} } = props;
  const [isError, setIsError] = useState(false);
  const prefixCls = usePrefixCls('thumbnail');

  useEffect(() => {
    setIsError(false);
  }, [imageUrl]);

  const classes = classnames(
    prefixCls,
    { 'is-active': !!active },
    className
  );

  const handleError = () => {
    setIsError(true);
  };

  const handleLoad = () => {
    setIsError(false);
  };

  const errorIcon = (
    <svg width="80" height="80" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect opacity="0.01" x="24" y="24" width="72" height="72" fill="white" />
      <path fillRule="evenodd" clipRule="evenodd" d="M30 84V36H90V84H30Z" fill="white" />
      <path fillRule="evenodd" clipRule="evenodd" d="M39 55.5H81V58.5H39V55.5Z" fill="#C1CCDD" />
      <path fillRule="evenodd" clipRule="evenodd" d="M39 66H69V69H39V66Z" fill="#C1CCDD" />
      <rect x="30" y="36" width="60" height="10.5" fill="#C1CCDD" />
      <rect opacity="0.01" x="72" y="66" width="30" height="30" fill="white" />
      <circle cx="87" cy="81" r="10.5" fill="white" />
      <path fillRule="evenodd" clipRule="evenodd" d="M87 69C80.373 69 75 74.373 75 81C75 87.627 80.373 93 87 93C93.627 93 99 87.627 99 81C99 74.373 93.627 69 87 69ZM88.5 87V84H85.5V87H88.5ZM88.5 75V82.5H85.5V75H88.5Z" fill="#006EFF" />
    </svg>
  );

  return (
    <div className={classes} style={style} onClick={() => onChoose()}>
      {!!imageUrl && (
        <>
          {isError ? (
            <div className={`${prefixCls}-error`}>
              <div className={`${prefixCls}-error__img`}>{errorIcon}</div>
            </div>
          ) : (
            <div className={`${prefixCls}__object`}>
              <img
                onLoad={handleLoad}
                className={`${prefixCls}__image`}
                src={imageUrl}
                onError={handleError}
                alt=""
              />
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default Thumbnail;
